import { useNavigate } from "react-router-dom";

function GoBack({ to }) {
  const navigate = useNavigate();

  const handleClick = () => {
    navigate(to ? to : -1);
  };

  return (
    <a
      className="p-4 text-decoration-none text-black goBack d-inline-flex align-items-center gap-2"
      style={{ fontSize: 25 }}
      data-testid="go-back-btn"
      onClick={handleClick}
    >
      <img src="/left-arrow.png" alt="" style={{ width: 16 }} />
      Back
    </a>
  );
}

export default GoBack;
